import React, {Suspense} from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Sizes } from "../../styles";
import Loading from "../Loading";

// state
import { AppProvider } from "./Context";

// comps
import Filters from "./Filters";
import JobGrid from "./JobGrid";

const App = () => {
	return (
		<Suspense fallback={<Loading aria-label="Loading..."/>}>
			<AppProvider>
				<ContentGrid role="main">
					<Filters />
					<JobGrid />
				</ContentGrid>
			</AppProvider>
		</Suspense>
	);
};

export default App;

App.propTypes = {
	pageTitle: PropTypes.string,
};

const ContentGrid = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5rem;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		display: grid;
		grid-template-columns: minmax(0, 35.9rem) minmax(0, 84.4rem);
		justify-content: space-between;
		gap: 5.2rem;
	}
`;
